export default "__VITE_ASSET__9c60bef4__"